import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { ShieldCheck, Database, HardDrive, Lock } from 'lucide-react';

const moats = [
  {
    title: 'Proprietary Datasets',
    icon: Database,
    desc: 'Exclusive access to multi-omic datasets across 100+ biomarkers for high-precision model training.'
  },
  {
    title: 'Vertical Integration',
    icon: HardDrive,
    desc: 'Own the entire stack from lab ingest to AI analysis to physical meal/supplement fulfillment.'
  },
  {
    title: 'High Switching Costs',
    icon: Lock,
    desc: 'The deeper the history of your biological data, the more valuable the platform becomes.'
  },
  {
    title: 'Regulatory Readiness',
    icon: ShieldCheck,
    desc: 'HIPAA-compliant infrastructure with architected paths for FDA SaMD (Software as a Medical Device) pathways.'
  }
];

const DefensibilityMoatSection: React.FC = () => {
  return (
    <section className="py-32 bg-theme-surface border-y border-theme-border relative">
      <Container>
        <div className="text-center mb-24">
          <h2 className="text-5xl font-black text-theme-text-primary mb-6 leading-tight">Building a Technical <br /> <span className="gradient-heading">Unfair Advantage.</span></h2>
          <p className="text-xl text-theme-secondary max-w-2xl mx-auto font-light leading-relaxed">
            BIOTUNE is architected for long-term category leadership through structural defensibility.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {moats.map((moat, idx) => (
            <motion.div
              key={moat.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="p-8 rounded-3xl bg-theme-elevated border border-theme-border hover:border-theme-primary/30 transition-all group shadow-sm hover:shadow-xl"
            >
              <div className="w-14 h-14 rounded-2xl bg-theme-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <moat.icon className="w-7 h-7 text-theme-primary" />
              </div>
              <h4 className="text-xl font-bold text-theme-text-primary mb-4">{moat.title}</h4>
              <p className="text-theme-secondary text-sm leading-relaxed">{moat.desc}</p>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default DefensibilityMoatSection;
